import Cookie from 'js-cookie';
import { authTokenName, cookieDomain } from 'src/env';

export const getBaseWidth = () => {
  if (process.browser) {
    const screenWidth = document.body.clientWidth;
    return screenWidth;
  }
};
/*宽度小于等于767*/
export const isMobile = () => {
  if (process.browser) {
    const baseWidth = getBaseWidth();
    return baseWidth <= 767;
  }
};
/*宽度大于1280*/
export const isPC = () => {
  if (process.browser) {
    const baseWidth = getBaseWidth();
    return baseWidth > 1280;
  }
};

export const isWidthLessThan1025 = () => {
  if (process.browser) {
    const baseWidth = getBaseWidth();
    return baseWidth < 1025;
  }
};

/*宽度在768(包含)到1280(包含)之间*/
export const isTablet = () => {
  if (process.browser) {
    const baseWidth = getBaseWidth();
    return baseWidth > 767 && baseWidth <= 1280;
  }
};
export default function isApp() {
  if (process.browser) {
    return !!navigator.userAgent.match(/zoomex_app/i);
  }
}
export const getGlobalLocaleMsg = () => {
  if (process.browser) {
    let storedData = {};
    try {
      const innerText =
        document.getElementById('__NEXT_DATA__')?.innerText || '{}';
      storedData =
        innerText && JSON.parse(innerText)
          ? JSON.parse(innerText)?.props?.pageProps?.localeMessages
          : {};
    } catch (e) {
      console.error(e);
    }
    return storedData;
  }
  return {};
};

// 更新 Cookie
export function setCookies(token: string) {
  console.log('setcookies: ', authTokenName, cookieDomain);
  Cookie.set(authTokenName, token, {
    expires: 7,
    path: '/',
    domain: cookieDomain,
  });
}

// 弹窗打开后不让页面滚动

export const setBodyScroll = (canScroll) => {
  if (canScroll) {
    document.body.style.overflow = 'auto';
  } else {
    document.body.style.overflow = 'hidden';
  }
};

// Load adjust script asynchronously
let loadByAppsFlyerPromise: Promise<unknown> | null = null;
const loadByAppsFlyerScript = (notDelayLoad: boolean) => {
  if (loadByAppsFlyerPromise) {
    return loadByAppsFlyerPromise;
  }
  const DOM_ID = 'adjust-script'; // dom id of script avoiding duplicate load
  const ADJUST = 'byAppsFlyers'; // global variable in window
  const ADJUST_CDN_URL =
    '/common-static/cht-static/user-svc/js/by_appsflyer_c67e7b7d.js';
  loadByAppsFlyerPromise = new Promise((resolve, reject) => {
    if (window[ADJUST]) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.id = DOM_ID;
    script.src = ADJUST_CDN_URL;
    script.defer = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      loadByAppsFlyerPromise = null;
      reject();
    };
    // Delay to append script avoiding lighthouse performance
    if (notDelayLoad) {
      document.body.appendChild(script);
    } else {
      setTimeout(() => {
        document.body.appendChild(script);
      }, 10000);
    }
  });
  return loadByAppsFlyerPromise;
};

// 获取adjust 链接
export const getAppLink = (deeplinkUrl) => {
  return loadByAppsFlyerScript(false).then(() => {
    return window?.byAppsFlyers?.getOneLink(deeplinkUrl);
  });
};
